import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from '../base/base.component';

declare var bootbox:any;

@Component({
  selector: 'app-demo-users-quick-actions',
  template: require('./demo-users-quick-actions.component.html'),
  styles: [require('./demo-users-quick-actions.component.css')]
})
export class DemoUsersQuickActionsComponent extends BaseComponent implements OnInit {

  @Output() downloadDemoReport = new EventEmitter<boolean>();

  ngOnInit() {
  }

  downloadDemoUsers() {
    this.downloadDemoReport.emit(true);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/demo-users-quick-actions/demo-users-quick-actions.component.ts